<div class="sidebar">
  <div class="sidebar-box" *ngFor="let sidebarBox of sidebar$ | async">
    <app-sidebar-box [sidebarBox]="sidebarBox"></app-sidebar-box>
  </div>
</div>
